<template>
  <div class="multi_question">    
    <div class="qes_txt" :style="{'color':surveyTheme.bodyColor}">
      <i class="qes_num" v-if="surveyTheme.openCode">{{data.showNum}}.</i>
      <div class="qes_name" v-html="data.qesName"></div>
    </div>
    <div class="answers">
      <van-checkbox-group :max="data.maxAnswer" v-model="showSelected">
        <div class="answers_box" v-for="(a,idx) in data.answers" :key="idx">
          <van-checkbox shape="square" :checked-color="color" :name="a.ansId" @click="selectAnswer(a,'select')">
            <div :style="fontSize == 1 ? {'color':color,'fontSize':'14px'} : {'color':color,'fontSize':'16px'}" class="answer_name" v-html="a.ansName"></div>
          </van-checkbox>
          <div v-if="a.hasInput && showSelected.indexOf(a.ansId) != -1" class="box">
            <input type="text" @blur="selectAnswer(a)" class="text_input" v-model="a.ansInput" placeholder="请输入">
          </div>
        </div>
      </van-checkbox-group>
    </div>
  </div>
</template>
<script>

 export default {
   components: { 
    
  },
  props: ['data','currentPage','index','color','fontSize'],
  watch: {  
    'data'(){
      console.log('多选题data值变了',this.data);
      this.showSelected = [];
      if(this.data.showSelected){
        this.showSelected = JSON.parse(this.data.showSelected);
        console.log('有值',this.showSelected);
      }else{
        console.log('没有值');
      }
    }
  },
  data(){
    return {
      surveyTheme:{},                         //问卷主题
      showSelected:[],                        //已选答案ID       (前端回显用)
      selectData:{},                          //已选答案相关对象 (提交后台用)
    }
  },
  created(){
    this.data.qesName = this.data.qesName.replaceAll('\n','<br/>');
    if(this.data.showSelected){
      this.showSelected = JSON.parse(this.data.showSelected);
      console.log(this.showSelected);
    }
    this.surveyTheme = JSON.parse(sessionStorage.getItem("surveyTheme"));
    this.data.answers.forEach(item=>{
      if(this.showSelected.length > 0){
        this.showSelected.forEach(ss=>{
          if(ss == item.ansId){
            item.checked = 1;
          }
        })
      }else{
        item.checked = 0;
      }
    })
    // if(this.showSelected.length > 0){
    //     this.showSelected.forEach(ss=>{
    //       if(ss == item.ansId){
    //         item.checked = 1;
    //       }
    //     })
    //   }
    // console.log(this.surveyTheme);
    console.log('多选题data',this.data);
  },
  methods:{
    selectAnswer(item,type){
      console.log('item:',item,'type:',type);
      console.log(this.showSelected);
      this.data.showSelected = JSON.stringify(this.showSelected);
      // if(type == 'select' && this.showSelected.length <= this.data.maxAnswer){
      //   console.log('满足条件。。。。。',this.showSelected.length,this.data.maxAnswer);
      //   if(this.showSelected.length == this.data.maxAnswer && this.showSelected.indexOf(item.qesId) == -1){
      //     return;
      //   }
      //   item.checked = item.checked == 1 ? 0 : 1;
      // }
      this.data.answers.forEach(x=>{
        x.checked = 0;
      })
      
      this.showSelected.forEach(i=>{
        this.data.answers.forEach(a=>{
          if(i == a.ansId){
            a.checked = 1;
          }
        })
      })
      item.textInput = item.ansInput;
      let obj = {};
      obj.ansExt = JSON.stringify(this.data.answers);
      obj.qesId = item.qesId;
      obj.surveyId = this.data.surveyId;
      obj.qesType = this.data.qesType;
      obj.otherType = this.data.otherType;
      obj.groId = this.data.groId;
      obj.qesName = this.data.qesName;
      obj.qesNum = this.data.qesNum;
      obj.qesOrder = this.data.qesOrder;
      this.selectData.gIndex = this.currentPage - 1;
      this.selectData.qIndex = this.index;
      this.selectData.submitQesObj = obj;
      console.log('this.data.answers:',this.data.answers);
      // console.log(this.selectData);
      this.$emit("sendAnswer",this.selectData);
    }
  }
}
</script>
<style lang="less" scoped>
  .multi_question{
    background-color: transparent;
    width: 100%;
    padding: 60px 40px;
    box-sizing: border-box;
    .qes_txt{
      margin-bottom: 40px;
      font-size: 36px;
      color: #333;
      line-height: 56px;
      display: flex;
      .qes_num{
        font-size: 34px;
        // line-height: 65px;
        margin-right: 10px;
      }
      .qes_name{
        font-size: 36px;
        display: inline;
        word-break: break-all;
      }
    }
    .answers{
      &:last-child{
        border-bottom: 1px solid #f6f6f6;
      }
      .answers_box{
        font-size: 32px;
        color: #4d4d4d;
        padding: 32px 0;
        box-sizing: border-box;
        border-top: 1px solid #f6f6f6;
        .answer_name{
          display: flex;
          align-items: center;
        }
        .box{
          margin-top: 20px;
          .text_input{
            width: 90%;
            padding: 15px 20px;
            font-size: 28px;
            border: 1px solid #f3eded;
            border-radius: 6px;
            color: #333;
            background-color: #fbfbfb;
          }
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/selectQuestion/multiQuestion.vue